<div class="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-1 gy-md md:gy-lg md:gx-lg">
  <slot></slot>
</div>